// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

export interface Theme {
    name: string;
    properties: any;
}

// Create a new theme for each tenant
// Each tenant must have the same properties or a color won't be applied
// We can give specific property names for

export const defaultTheme: Theme = {
    name: 'default',
    properties: {
        // general
        '--font-family': '"Roboto", sans-serif',
        '--disabled-opacity': '0.5',
        '--hr-color': '#acacac',
        '--box-shadow': '0 2px 1px -2px rgb(200 200 200), 0 2px 2px 0 rgb(210 210 210), 0 1px 5px 0 rgb(220 220 220)',

        '--white': '#FFFFFF',
        '--grey': '#878787',
        '--light-grey': '#e1e1e1',
        '--dark-grey': '#333333',
        '--black': '#000000',

        '--success': '#8EC23F', // dark green, secondary
        '--error': '#af0000', // red

        // color palette
        '--primary-color': '#0D2744', // dark blue, primary
        '--cta-color': '#f2a327', // dark yellow
        '--secondary-color': '#8DC63F', // bright green, primary
        '--color-three': '#F5CA12', // yellow, secondary
        '--color-four': '#215792', // medium blue, secondary
        '--color-five': '#70993E', // dark green, secondary
        '--color-six': '#3A81CE', // light blue, secondary
        '--color-seven': '#F36621', // red, secondary

        // layout
        '--tenant-header': '#1A428A',
        '--tenant-primary-light': '#8d95a5',
        '--user-header': '#FFFFFF',
        '--layout': '#F7F7F7',
        '--nav-icon-color': '#ffffff',
        '--side-nav': '#071A39',
        '--selected-nav': '#0180c1',
        '--footer': '#878787',
    },
};

export const chryslerTheme: Theme = {
    name: 'chrysler',
    properties: {
        // general
        '--font-family': '"Roboto", sans-serif',
        '--disabled-opacity': '0.5',
        '--hr-color': '#acacac',
        '--box-shadow': '0 2px 1px -2px rgb(200 200 200), 0 2px 2px 0 rgb(210 210 210), 0 1px 5px 0 rgb(220 220 220)',

        '--white': '#FFFFFF',
        '--grey': '#878787',
        '--light-grey': '#e1e1e1',
        '--dark-grey': '#333333',
        '--black': '#000000',

        '--success': '#8EC23F', // dark green, secondary
        '--error': '#af0000', // red

        // color palette
        '--primary-color': '#0D2744', // dark blue, primary
        '--cta-color': '#f2a327', // dark yellow
        '--secondary-color': '#8DC63F', // bright green, primary
        '--color-three': '#F5CA12', // yellow, secondary
        '--color-four': '#215792', // medium blue, secondary
        '--color-five': '#70993E', // dark green, secondary
        '--color-six': '#3A81CE', // light blue, secondary
        '--color-seven': '#F36621', // red, secondary

        // layout
        '--tenant-header': '#000000',
        '--tenant-primary-light': '#777777',
        '--user-header': '#FFFFFF',
        '--layout': '#F7F7F7',
        '--side-nav': '#212121',
        '--nav-icon-color': '#ffffff',
        '--selected-nav': '#063e77',
        '--footer': '#000000',
    },
};

export const testTheme: Theme = {
    name: 'test',
    properties: {
        '--font-family': 'cursive',
        '--primary-color': 'purple',
        '--primary-color-dark': 'indigo',
        '--secondary-color': 'red',
        '--hover-background': '',
        '--hover-border': '',
        '--selected-text': '',
        '--selected-background': '',
        '--selected-border': '',
        '--disabled-opacity': '0.5',
        '--hr-color': 'teal',
        '--white': 'white',
        '--black': 'black',
        '--success': 'green',
        '--error': 'red',
    },
};

export const themes: Theme[] = [defaultTheme, chryslerTheme, testTheme];
